import AbsModule from '../common/AbsModule';
import { NSHOP_COUPON_DOMAIN, SHORTCUT, getShortcutDefaultList } from '../common/const';

class Shortcut extends AbsModule {
    constructor(_config) {
        super(_config.shortCut, _config.shortCut.isShow);
        this.dataBindList = [];
        this.showArrowBtnLength = 5; // shortcut 5개부터 .ncc-shortcut-btn 버튼 노출하도록
        this.shortcutData = this.setShortcutData();
        this.isMobile = this.com?.isMobile;
    }

    startSetting() {
        let shortcutUL = jQuery('#nc-cnb .ncc-shortcut-list');

        if (this.isMobile) {
            jQuery('#nc-cnb .ncc-shortcut-item__link__mypage')
                .off('click')
                .on('click', e => {
                    let url = jQuery(e.currentTarget).attr('href');
                    window.open(url, 'myPage');
                    return false;
                });

            shortcutUL.css({'overflow-x': 'auto'});
        } else {
            this.showArrowBtn(); // arrow btn 노출/숨김

            jQuery(window).on('resize.shortcut', e => {
                this.showArrowBtn(); // arrow btn 노출/숨김
            });
            //jQuery(window).trigger('resize.shortcut');
        }

        // function 타입 숏컷
        const { purpleCheck, env } = this.com || {};
        const { isPurpleApp } = purpleCheck;

        jQuery('.ncc-shortcut-item__link[data-func-name]').click(function () {
            const funcName = jQuery(this).data('func-name');
            const funcParams = jQuery(this).data('func-params');

            let $this = this;

            const func = funcName.split('.').reduce((acc, curVal) => {
                const obj = acc[curVal];
                if (typeof obj === 'object') {
                    $this = obj;
                }
                return obj;
            }, window);

            if (jQuery.isFunction(func)) {
                if(isPurpleApp && funcParams?.popup_service === 'nshop_coupon') { // 퍼플 모바일앱(인앱)일 때, 내부 이동
                    location.href = NSHOP_COUPON_DOMAIN[env];
                } else {
                    func.call($this, funcParams);
                }
            }
            return false;
        });
    }

    makeMarkup() {
        const data = this.shortcutData;
        const l10nD = this.com.l10nData.Shortcut;
        const listLng = data?.length || 0;

        if(!Array.isArray(data) || data?.length === 0) {
            return '';
        }

        return `
        <nav class="ncc-shortcut">
            <strong class="blind">${l10nD.GotoService}</strong>
            <ul id="ncc-shortcut-list" class="ncc-shortcut-list ncc-shortcut-list-length${listLng}">
                ${data?.map(v => {
                    const key = v[0];
                    const value = v[1];

                    if(!this.isMobile && key === SHORTCUT.GIFT.key) {
                        return '';
                    }

                    return [SHORTCUT.COUPON_GAME.key, SHORTCUT.NPOINT_GAME.key]?.includes(key) ? this.makeItem(value, 'game') : this.makeItem(value);
                })?.join('')}
            </ul>
            <button type="button" class="ncc-shortcut-btn ncc-shortcut-btn--prev" style="display:none;">&lt;</button>
            <button type="button" class="ncc-shortcut-btn ncc-shortcut-btn--next" style="display:none;">&gt;</button>
        </nav>`;
    }

    // shortcut 데이터 가공
    setShortcutData() {
        const { isNct, isNcj, rcDash } = this.com || {};

        // configData?.key?.isShow: true 추출 및 cnbConfig.isShow / cnbConfig.useCustom 제거 / NCT/NCJ일 때 charHome 제거
        const setConfigData = (obj = {}) => {
            delete obj?.isShow;
            delete obj?.useCustomSort;

            for(let key in obj) {
                if(!obj[key] || (typeof obj[key] === 'object' && !obj[key]?.isShow) || ((isNct || isNcj) && key === SHORTCUT.CHAR_HOME.key)) {
                    delete obj[key];
                }
            }

            return obj;
        };
        
        
        const l10nD = this.com.l10nData.Shortcut;
        const useCustomSort = this.moduleData?.useCustomSort || false; // shortcut 정렬 순서(default: false(SHORTCUT에 정의된 순서) / true: cnbConfig.shortCut에서 정의한 순서)
        const defaultData = getShortcutDefaultList(rcDash);
        const configData = setConfigData({...this.moduleData}) || {};
        const nshopData = window.userData.nshop || window.userData.nShop || {};
        const defaultDataKeys = Object.keys(defaultData);
        const configDataKeys = Object.keys(configData);
        const sortArr = useCustomSort ? configDataKeys : defaultDataKeys?.filter(v => configDataKeys?.includes(v));
        let newData = [];

        sortArr?.forEach(key => {
            const defaultValue = defaultData[key] || {};
            const configValue = configData[key] || {};
            const { l10nKey } = defaultValue;
            let value = typeof configValue === 'object' ? {...defaultValue, ...configValue} : typeof configValue === 'boolean' ? {...defaultValue, isShow: configValue} : {...defaultValue};
            
            value['title'] = l10nKey ? l10nD[l10nKey] : '';

            if([SHORTCUT.NCOIN.key, SHORTCUT.ENTER_COUPON.key].includes(key)) {
                const isEnterCoupon = key === SHORTCUT.ENTER_COUPON.key;
                const { iconClass, title } = this.getShortCutItem({
                    name: value['iconClass'], 
                    l10n: value['title'], 
                    count: isEnterCoupon ? nshopData.coupon : nshopData.nCoin || nshopData.ncoin, 
                    maxCount: isEnterCoupon ? 99 : 999999, 
                    prefix: isEnterCoupon ? l10nD.CouponLang : '{}'
                }) || {};
                
                value['title'] = title;
                value['iconClass'] = iconClass;
            }

            newData.push([key, value]);
        });

        return newData;
    }

    // shortcut.length >= 5 인지 확인 후, .ncc-shortcut-btn 버튼 노출
    showArrowBtn() {
        const $shortcut = jQuery('.ncc-shortcut');
        const itemLength = jQuery('#nc-cnb .ncc-shortcut-list .ncc-shortcut-item').length;
        const isShowArrowBtn = itemLength >= this.showArrowBtnLength;

        jQuery('#nc-cnb .ncc-shortcut-btn').toggle(isShowArrowBtn);

        if(isShowArrowBtn) {
            this.addArrowBtnEvent();
            $shortcut.addClass('show-arrow-btn');
        } else {
            $shortcut.removeClass('show-arrow-btn');
        }
    }

    addArrowBtnEvent() {
        const $shortcutUL = jQuery('#nc-cnb .ncc-shortcut-list');
        const $item = jQuery('#nc-cnb .ncc-shortcut-list .ncc-shortcut-item');

        jQuery('#nc-cnb .ncc-shortcut-btn--prev')
            .off('click')
            .on('click', e => {
                const itemWidth = $item.width();
                const nowScrLeft = $shortcutUL.scrollLeft();
                $shortcutUL.animate({
                    scrollLeft: nowScrLeft - (itemWidth * 3)
                }, 250);
            });

        jQuery('#nc-cnb .ncc-shortcut-btn--next')
            .off('click')
            .on('click', e => {
                const itemWidth = $item.width();
                const nowScrLeft = $shortcutUL.scrollLeft();
                $shortcutUL.animate({
                    scrollLeft: nowScrLeft + (itemWidth * 3)
                }, 250);
            });
    }

    getShortCutItem({ name, l10n, count, maxCount, prefix }) {
        let iconClass = name,
            title = l10n;
        if (count) {
            title = this.getShortCutNumber(count, maxCount);
            if (title === '' || parseInt(title, 10) === 0) {
                title = l10n;
            } else {
                iconClass += ' is-number';
                title = prefix.replace('{}', title);
            }
        }

        return {
            iconClass,
            title
        };
    }

    getShortCutNumber(num, maxCount) {
        if (jQuery.isNumeric(num)) {
            num = num
                .toString()
                .replace(/^\s\s*/, '')
                .replace(/\s\s*$/, '');
            let chkNum = parseInt(num, 10),
                isFull = '';
            if (chkNum > maxCount) {
                num = maxCount.toString();
                isFull = '+';
            }
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + isFull;
        } else {
            return '';
        }
    }

    makeItem(value, suffix = '') {
        if (!value || !value?.isShow) {
            return '';
        }

        let { iconType, type, url, title, iconClass, popupName, popOption, name, params } = value || {};
        let linkType = iconType || type;
        let aTag = '';

        switch (linkType) {
            case 'popup':
                aTag = `<a href="javascript:void(0)" onclick="window.open('${url}', '${this.com?.setLinkTarget(popupName)}', '${popOption}').focus(); return false;" class="ncc-shortcut-item__link">`;
                break;
            case 'function':
                aTag = `<a href="#" class="ncc-shortcut-item__link" data-func-name="${name}" data-func-params='${JSON.stringify(params)}' >`;
                break;
            default:
                aTag = `<a href="${url}" target="${linkType === 'external'? '_blank': '_self'}" class="ncc-shortcut-item__link">`;
        }

        return `
        <li class="ncc-shortcut-item">
            ${aTag}
                <i class="icon-shortcut icon-shortcut--${iconClass}"></i>
                <span class="desc" id="ncc-shortcut-databind-${iconClass}${suffix ? `-${suffix}` : '' }">${title}</span>
            </a>
        </li>`;
    }




}

export default Shortcut;